import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Phone } from "lucide-react";
import SEO from "../components/SEO";
import { PageHero } from "./Services";
import { brand } from "../data/site";

const NotFound = () => (
  <div>
    <SEO title="Page Not Found | Pepla Roofing" description="The page you're looking for doesn't exist." />
    <PageHero eyebrow="404" title="Page Not Found" subtitle="The page you're looking for has moved or doesn't exist." />
    <section className="py-20 bg-background text-center">
      <div className="max-w-xl mx-auto px-5 flex flex-wrap justify-center gap-4">
        <Link to="/" className="bg-brand hover:bg-brand-light text-ink font-semibold uppercase tracking-wider text-sm px-8 py-4 rounded-md transition-colors inline-flex items-center gap-2">
          Back to Home <ArrowRight size={18} />
        </Link>
        <a href={`tel:${brand.phoneRaw}`} className="border border-ink/15 hover:border-brand font-semibold uppercase tracking-wider text-sm px-8 py-4 rounded-md transition-colors inline-flex items-center gap-2">
          <Phone size={18} className="text-brand" /> {brand.phone}
        </a>
      </div>
    </section>
  </div>
);

export default NotFound;
